import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import withLocalization from '../../hoc/withLocalization';

class UnderMaintenace extends Component {
    render() {
        return (
            <>
                <center>
                    <h3>{this.props.t('This feature is under maintenance, we will be back next year')}!</h3>
                    <img src="/images/under_maintanace.webp" style={{ width: '50%' }} />
                </center>
            </>
        );
    }
}

export default inject('commonStore')(withLocalization(observer(UnderMaintenace)));
